import _u from './utility';
import _v from './vars';
import _fn from './main-fn';

//s_ variables read from page overwrite previously set context variables
const overWrites = function() {
		
    if (typeof _v.g['s_context'] == 'object') {
		Object.keys(_v.g['s_context']).forEach(function(key) {
            if (typeof _v.g['s_context'][key] !== 'undefined') {
				_fn.wmdSetContext(key, _v.g['s_context'][key]);
			}
        });
    }

	// Check promoActivity for values to pass
	function chkPromoKey(key) {
		if (typeof key !== 'undefined' && key !== null && Number(key) !== 0) {
			return true;
		} else {
			return false;
		}
	}

	_v.sOvrRide.forEach(function(d) {
		if (typeof window[d] !== 'undefined' && (_v.promoOvrRide.indexOf(d) == -1 || typeof networkGate !== 'object' || Object.keys(networkGate).length == 0)) {
			_fn.wmdSetContext('wb.' + d.split('_')[1], window[d]);
		}
		if (typeof networkGate !== 'object' || Object.keys(networkGate).length == 0)  {
			if (typeof promoActivity == 'object' && Object.keys(promoActivity).length > 0) {
				var trkObj = {
					'wb.sactid': promoActivity.id,
					'wb.sact': promoActivity.salesforceNumber,
					'wb.sprodid': promoActivity.subProductId,
					'wb.sprod': promoActivity.subProductName,
					'wb.sptr': promoActivity.deptName + " [ " + promoActivity.deptId + " ]"
				};
				if (typeof trkObj['wb.' + d.split('_')[1]] !== 'undefined') {
					if (chkPromoKey(trkObj['wb.' + d.split('_')[1]])) {
						_fn.wmdSetContext('wb.' + d.split('_')[1], trkObj['wb.' + d.split('_')[1]].toString().toLowerCase().replace(/'/g,''));
					}
				}
				if (typeof promoActivity.deptName != 'undefined' && typeof promoActivity.deptId != 'undefined') {
					window.s_sptr = promoActivity.deptName + " [ " + promoActivity.deptId + " ]";
				}
				if (typeof promoActivity.salesforceNumber != 'undefined') {
					window.s_sact = promoActivity.salesforceNumber;
				}
				if (typeof promoActivity.id != 'undefined') {
					window.s_sactid = promoActivity.id;
				}
				if (typeof promoActivity.subProductId != 'undefined') {
					window.s_sprodid = promoActivity.subProductId;
				}
				if (typeof promoActivity.subProductName != 'undefined') {
					window.s_sprod = promoActivity.subProductName;
				}
			}
		}
	});

	if (typeof networkGate == 'object' && Object.keys(networkGate).length > 0)  { 
		var trkObj = {
			'wb.actid': networkGate.a,
			'wb.instid': networkGate.i,
			'wb.expandedbrandid': networkGate.expandedBrandId,
			'wb.salesforcedeliverableid': networkGate.sfDeliverableID,
			'wb.salesforcedeliverablename': networkGate.sfDeliverableName,
			'wb.bundleid': networkGate.bundleId
		};
		Object.keys(trkObj).forEach(function(key)  {
			if (chkPromoKey(trkObj[key])) {
				if (_v.lowerCaseOvrRide.indexOf(key) != -1) {
					_fn.wmdSetContext(key, trkObj[key].toString().replace(/'/g,''));
				}
				else {
					_fn.wmdSetContext(key, trkObj[key].toString().toLowerCase().replace(/'/g,''));
				}
			}
		});
	}
	
	if (typeof s_md.contextData['wb.sact'] == 'undefined' || s_md.contextData['wb.sact'] == null || s_md.contextData['wb.sact'].trim() == '') {
		_fn.wmdRemContext('wb.engmt');
	}			

};

export default overWrites;